module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.newClass,
    style: ({
      width: _vm.width,
      height: _vm.height,
      backgroundColor: _vm.backgroundColor,
      color: _vm.textColor
    }),
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function (e) { return !_vm.disabled && _vm.$emit('click', e); }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d37cc162","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/form/DefaultButton.vue
// module id = 3375
// module chunks = 0